import React from 'react';
import { Panel } from 'primereact/panel';

export default function SeoLiveCodePreview({ watchedImageUrl }) {
    const imageUrl = watchedImageUrl?.url;
    return (
        <div className="grid p-justify-center p-m-4">
            <div className="col-6">
                <Panel header="Image preview">
                    <div style={{
                        backgroundColor: '#f8fafc',
                        padding: '1rem',
                        borderRadius: '8px',
                        textAlign: 'center'
                    }}>
                        {imageUrl && (
                            <img
                                src={imageUrl}
                                alt="SEO Preview"
                                style={{ width: '100%', borderRadius: '8px' }}
                            />
                        )}
                    </div>
                    <small style={{ color: '#64748b', display: 'block', marginTop: '0.5rem', textAlign: 'center' }}>
                        {watchedImageUrl?.caption}
                    </small>
                    <small style={{ color: '#64748b', display: 'block', marginTop: '0.5rem', textAlign: 'center' }}>
                        {watchedImageUrl?.credits && (
                            <span>
                                Créditos:&nbsp;
                                {watchedImageUrl.credits.source?.url ? (
                                    <a
                                        href={watchedImageUrl.credits.source.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: '#0ea5e9' }}
                                    >
                                        {watchedImageUrl.credits.source.text || watchedImageUrl.credits.source.url}
                                    </a>
                                ) : (
                                    watchedImageUrl.credits.source?.text
                                )}
                                {watchedImageUrl.credits.author && (
                                    <>
                                        &nbsp;images por&nbsp;
                                        {watchedImageUrl.credits.author.url ? (
                                            <a
                                                href={watchedImageUrl.credits.author.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: '#0ea5e9' }}
                                            >
                                                {watchedImageUrl.credits.author.text || watchedImageUrl.credits.author.url}
                                            </a>
                                        ) : (
                                            watchedImageUrl.credits.author.text
                                        )}
                                    </>
                                )}
                            </span>
                        )}
                    </small>
                </Panel>
            </div>
            <div className="col-6">
                <Panel header="HTML result">
                    <div style={{
                        backgroundColor: '#1e293b',
                        color: '#f1f5f9',
                        borderRadius: '8px',
                        overflowX: 'auto',
                        padding: '1rem',
                        fontFamily: 'monospace',
                        fontSize: '14px',
                        whiteSpace: 'pre',
                        wordBreak: 'keep-all',
                        overflowWrap: 'normal',
                    }}>
                        <pre style={{ margin: 0, whiteSpace: 'pre', overflowX: 'auto' }}>
                            <code style={{ whiteSpace: 'pre', wordBreak: 'keep-all', overflowWrap: 'normal' }}>
                                <span style={{ color: '#f472b6' }}>{`<image`}</span><br />
                                <span style={{ paddingLeft: '1rem', color: '#67e8f9' }}>src=</span>
                                <span style={{ color: '#fde68a' }}>
                                    {`${watchedImageUrl?.url?.length > 40 ? watchedImageUrl?.url.slice(0, 40) + '...' : watchedImageUrl?.url}`}
                                </span><br />
                                <span style={{ paddingLeft: '1rem', color: '#67e8f9' }}>title=</span>
                                <span style={{ color: '#6ee7b7' }}>
                                    {`"${watchedImageUrl?.title?.length > 40 ? watchedImageUrl?.title.slice(0, 40) + '...' : watchedImageUrl?.title}"`}
                                </span><br />
                                <span style={{ paddingLeft: '1rem', color: '#67e8f9' }}>alt=</span>
                                <span style={{ color: '#6ee7b7' }}>
                                    {`"${watchedImageUrl?.alt?.length > 40 ? watchedImageUrl?.alt.slice(0, 40) + '...' : watchedImageUrl?.alt}"`}
                                </span><br />
                                <span style={{ paddingLeft: '1rem', color: '#67e8f9' }}>style=</span>
                                <span style={{ color: '#fcd34d' }}>{`{{ width: ${watchedImageUrl?.width || 0}px, height: ${watchedImageUrl?.height || 0}px }}`}</span><br />
                                <span style={{ color: '#f472b6' }}>{`/>`}</span>
                                <br />
                                <br />
                                <span style={{ color: '#f472b6' }}>{`<span>`}</span><br />
                                    <span style={{ paddingLeft: '1rem', color: '#67e8f9' }}>
                                        {watchedImageUrl?.caption?.length > 40 ? watchedImageUrl?.caption.slice(0, 40) + '...' : watchedImageUrl?.caption}
                                    </span><br />
                                <span style={{ color: '#f472b6' }}>{`</span>`}</span><br />
                                <br />
                                <span style={{ color: '#f472b6' }}>{`<span>`}</span><br />
                                    <span style={{ paddingLeft: '1rem', color: '#67e8f9' }}>
                                        {watchedImageUrl?.credits && (
                                            <>
                                                Créditos:&nbsp;<br />
                                                {watchedImageUrl.credits.source?.url ? (
                                                    <span style={{ color: '#0ea5e9' }}>
                                                        {`<a href="${watchedImageUrl.credits.source.url?.slice(0, 40) + '...'}"  target="_blank" rel="noopener noreferrer">`}
                                                        {watchedImageUrl.credits.source.text?.length > 40
                                                            ? watchedImageUrl.credits.source.text.slice(0, 40) + '...'
                                                            : (watchedImageUrl.credits.source.text || watchedImageUrl.credits.source.url?.slice(0, 40) + '...')}
                                                        {`</a>`}
                                                    </span>
                                                ) : (
                                                    watchedImageUrl.credits.source?.text?.length > 40
                                                        ? watchedImageUrl.credits.source.text.slice(0, 40) + '...'
                                                        : watchedImageUrl.credits.source?.text
                                                )}<br />
                                                {watchedImageUrl.credits.author && (
                                                    <>
                                                        &nbsp;images por&nbsp;<br />
                                                        {watchedImageUrl.credits.author.url ? (
                                                            <span style={{ color: '#0ea5e9' }}>
                                                                {`<a href="${watchedImageUrl.credits?.author?.url?.slice(0, 20)}" target="_blank" rel="noopener noreferrer">`}
                                                                {watchedImageUrl.credits.author.text?.length > 20
                                                                    ? watchedImageUrl.credits.author.text.slice(0, 20) + '...'
                                                                    : (watchedImageUrl.credits.author.text || watchedImageUrl.credits.author.url?.slice(0, 20) + '...')}
                                                                {`</a>`}
                                                            </span>
                                                        ) : (
                                                            watchedImageUrl.credits.author.text?.length > 20
                                                                ? watchedImageUrl.credits.author.text.slice(0, 20) + '...'
                                                                : watchedImageUrl.credits.author.text.slice
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </span><br />
                                <span style={{ color: '#f472b6' }}>{`</span>`}</span><br />
                            </code>
                        </pre>
                    </div>
                </Panel>
            </div>
        </div>
    );
}
